<template>
	<div class="home">
		<!-- <div style="position: absolute; background-color: #5856eb; width: 100%; height: 599px;">
			
		</div> -->
		<div class="com-header">
			<div class="com-header-row">

				<div class="com-header-avatar">


					<div :span="4" class="com-header-col">
						<img src="../../../public/images/home/人物_03.png">
					</div>
					<div :span="4" class="com-header-col">
						<img src="../../../public/images/home/人物_05.png">
					</div>
					<div :span="4" class="com-header-col">
						<img src="../../../public/images/home/人物_07.png">
					</div>
					<div :span="4" class="com-header-col">
						<img src="../../../public/images/home/人物_09.png">
					</div>
					<div :span="4" class="com-header-col">
						<img src="../../../public/images/home/人物_11.png">
					</div>
				</div>
			</div>
			<el-button style="font-size: 1rem;" class="button" round>免费体验</el-button>
		</div>

		<el-row class="row-header">
			<el-col :span="6" class="equal-height">
				<el-card class="box-card" shadow="hover">
					<img src="../../../public/images/home/一体机.svg">
					<span>AI + 数字人智慧一体机</span>
				</el-card>
			</el-col>
			<el-col :span="6" class="equal-height">
				<el-card class="box-card" shadow="hover">
					<img src="../../../public/images/home/百事通.svg">
					<span>AI + 24小时助教/学校百事通</span>
				</el-card>
			</el-col>
			<el-col :span="6" class="equal-height">
				<el-card class="box-card" shadow="hover">
					<img src="../../../public/images/home/微课系统.svg">
					<span>AI + 数字教师慕课/微课</span>
				</el-card>
			</el-col>
			<el-col :span="6" class="equal-height">
				<el-card class="box-card" shadow="hover">
					<img src="../../../public/images/home/虚拟仿真.svg">
					<span>AI + 仿真实训</span>
				</el-card>
			</el-col>
		</el-row>

		<!-- 
		<div class="com-content">
			<div style="font-size: 2vw;">
				AIGC+工具箱:
			</div>
			<div class="toolbox-card">
				<el-button @click="redirectTo('https://ai-image.yigee.cn/')">
					AI绘图（文生图、图生图）
				</el-button>
				<el-button @click="redirectTo('https://ai-image.yigee.cn/')">
					图生3D模型
				</el-button>
				<el-button @click="redirectTo('https://ai-image.yigee.cn/')">
					视频高调处理
				</el-button>
				<el-button @click="redirectTo('https://ai-image.yigee.cn/')">
					<span>图像智能处理</span>
					<br />
					<span>（背景、水印、风格化、高清放大）</span>
				</el-button>
			</div>
		</div> -->

		<el-row>
			<el-col>
				<div class="model-title">
					<img src="../../../public/images/icon02.svg">虚拟实训产品
				</div>
			</el-col>
			<el-col :span="24">
				<vueVirtualsim></vueVirtualsim>
			</el-col>
		</el-row>

		<el-row>
			<el-col>
				<div class="model-title">
					<img src="../../../public/images/icon03.svg">公司简介
				</div>
			</el-col>
			<el-col :span="24" style="margin-bottom: 40px;">
				<vue-company-profile></vue-company-profile>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import vueVirtual from '../../components/vue-virtual'
	import vueTurntable from '../../components/vue-turntable'
	import vueVirtualsim from '../../components/vue-virtualsim'
	import vueCompanyProfile from '../../components/vue-company-profile'

	import {
		mapState,
		mapMutations
	} from 'vuex'
	export default {
		components: {
			vueVirtual,
			vueTurntable,
			vueVirtualsim,
			vueCompanyProfile
		},
		data() {
			return {
				activeIndex: '1',
				banner: [
					'/videos/banner01.webm',
					'/images/banner01.jpg',
					'/images/banner02.jpg',
					'/images/banner03.jpg',
					'/images/banner04.jpg'
				],
				number: 0,
				statistics: [{
						number: 0,
						maxnum: 700,
						more: true,
						title: '虚拟仿真成品实验',
						info: '拥有700+虚拟仿真实验成品，覆盖药学、医学、生物、食品、建筑、土木、矿业、轻工、机械等多学科领域。'
					},
					{
						number: 0,
						maxnum: 1300,
						more: true,
						title: '合作院校',
						info: '与全国1300+高职高专、本科院校合作。'
					},
					{
						number: 0,
						maxnum: 50,
						more: true,
						title: '软件著作权',
						info: '拥有50+包含多学科虚拟仿真课程系统、智慧云教学平台、VR课程系统等产品软著'
					}
				],
				proinfo: [{
						img: '/images/66.svg',
						path: '/home/program/page3',
						title: '医药学虚拟仿真课程建设',
						info: '易格提供全学科定制化虚拟仿真实验教学资源建设全套解决方案。 提供多学科虚拟仿真产品。涵盖药学、医学、生物、食品、建筑、土木、矿业、轻工、机械等学科。'
					},
					{
						img: '/images/99.svg',
						path: '/home/program/page1',
						title: '示范性VR虚拟仿真实训基地建设',
						info: '提供由VR大屏级显示系统、VR手柄头盔交互系统、VR桌面级仿真实验系统、VR移动式仿真实验系统以及虚拟仿真课程资源集成解决方案。'
					},
					{
						img: '/images/77.svg',
						path: '/home/program/page2',
						title: '国家级虚拟仿真一流金课建设方案',
						info: '提供前期顶层设计、实验制作、申报材料制作、平台集成、实验空间对接等全流程服务。全流程、全技术栈定制开发定制虚拟仿真项目。'
					},
					// {
					// 	img: '/images/99.svg',
					// 	title: '虚拟仿真实验+平台定制方案',
					// 	info: '全流程、全技术栈定制开发虚拟仿真项目。'
					// }
				],
				news: []
			}
		},
		created() {
			let interval = new Promise((resolve, reject) => {
				let step = 5
				const timeTop = setInterval(() => {

					this.statistics.map(a => {
						a.number += a.maxnum / 100

						if (a.number > a.maxnum) {
							a.number = a.maxnum
							clearInterval(timeTop); //清除定时器
							resolve()
						}
					})
				}, 10);
			})
			interval
		},
		mounted() {
			this.News()
		},
		methods: {
			...mapMutations(['setNews']),
			handleCarouselItem(e) {
				switch (e) {
					case 0:
						this.$router.push('/home/product2/myszjspt');
						break;
					case 1:
						window.open('http://yigee.cn/vr/index.html')
						break;
					case 2:
						this.$router.push('/home/program/page10');
						break;
					case 3:
						this.$router.push('/home/product2/details/a94235b4-955c-11ec-abc1-00163e0400dc');
						break;
					case 4:
						window.open('http://yunfangzhen.yigee.cn/login')
						break;
				}
			},
			News() {
				this.$http.get('news/GetNews.do').then(res => {
					this.news = res.data
					this.setNews(res.data)
				})
			},
			handleSelect(key, keyPath) {
				// 处理菜单项点击事件
			},
			redirectTo(url) {
				window.open(url, '_blank')
			}
		}
	}
</script>

<style scoped>
	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}

	.el-row:last-child {
		margin-bottom: 0;
	}

	.el-col {
		border-radius: 4px;
	}

	.bg-purple-dark {
		background: #99a9bf;
	}

	.bg-purple {
		background: #d3dce6;
	}

	.bg-purple-light {
		background: #e5e9f2;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
		height: 400px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}

	.pro {
		/* padding: 60px 0; */
		width: 1280px;
		margin: auto;
	}

	.pro a {
		text-decoration: none;
	}

	.proinfo {
		text-align: center;
		font-size: 20px;
		line-height: 50px;
	}

	.proinfo img {
		height: 100px;
		width: 100px;
		cursor: pointer;
		margin: 0 auto;
		display: block;
		transition: all 0.5s;
	}

	.proinfo img:hover {
		transform: scale(1.3);
		-ms-transform: scale(1.3);
		/* IE 9 */
		-moz-transform: scale(1.3);
		/* Firefox */
		-webkit-transform: scale(1.3);
		/* Safari 和 Chrome */
		-o-transform: scale(1.3);
		/* Opera */
	}

	.proinfo span {
		font-size: 18px;
		color: #000000;
		font-weight: 700;
		line-height: 60px;
	}

	.proinfo .info-text {
		width: 80%;
		height: 110px;
		margin: 0 auto;
		border-top: 1px solid #ccc;
		font-size: 14px;
		text-align: left;
		line-height: 25px;
		color: #7f889c;
	}



	.statistics {
		width: 1280px;
		margin: 0 auto;
		background-color: #fff;
		height: 200px;
		text-align: center;
		line-height: 40px;
		/* 设置 动画名称 和 执行时间 */
		animation-name: mymove;
		animation-duration: 1s;
		-webkit-animation-name: mymove;
		-webkit-animation-duration: 1s;
	}

	/* 设置动画 起止位置 */
	@keyframes mymove {
		from {
			left: -800px;
		}

		to {
			left: 0px;
		}
	}

	@-webkit-keyframes mymove

	/* Safari and Chrome */
		{
		from {
			left: -1500px;
		}

		to {
			left: 0px;
		}
	}

	.statistics .num {
		height: 57px;
		font-size: 48px;
		font-weight: 700;
		color: #007985;
		line-height: 57px;
	}


	.model-title {
		height: 60px;
		font-size: 30px;
		font-weight: 600;
		color: #00113a;
		line-height: 60px;
		text-align: left;
		width: 1280px;
		border-bottom: 1px solid #eee;
		margin: 60px auto 40px auto;
	}

	.model-title img {
		width: 30px;
		height: 30px;
		vertical-align: text-bottom;
		margin-right: 15px;
	}


	.statistics .info {
		width: 80%;
		margin: 0 auto;
		margin-top: 16px;
		height: 40px;
		font-size: 14px;
		font-weight: 400;
		color: #7f889c;
		line-height: 20px;
	}


	.news {
		width: 1280px;
		margin: auto;
	}

	.news .news-item:hover {
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
		margin-left: 20px;
	}

	.news .news-item {
		margin-top: 10px;
		padding: 30px;
		position: relative;
		width: 100%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 10px 0px transparent;
		transition: .3s;
	}

	.news .news-item a {
		text-decoration: none;
		color: #000;
		line-height: 28px;
	}

	.news .news-item a img {
		width: 280px;
		height: 170px;
	}

	.news .news-item a .item-text-title {
		padding-left: 20px;
		font-size: 18px;
		font-weight: 700;
	}

	.news .news-item a .item-text-content {
		padding-left: 20px;
		color: #192944;
		font-size: 14px;
		text-indent: 1rem;
	}

	.news .news-item a .item-text-date {
		padding-left: 20px;
		color: #9BA5B7;
	}
</style>

<style scoped>
	.home {
		margin-top: -60px;
		width: 100%;
	}

	.com-header {
		display: block;
		position: relative;
		background-image: url('../../../public/images/home/底图.png');
		/* 更换为你的背景图路径 */
		background-size: 100% 100%;
		background-position: center;
		background-repeat: no-repeat;
		color: #fff;
		text-align: center;
		margin: auto;
		width: 100%;
		padding-top: 40%;
		height: 0;
	}

	.com-header .el-button {
		align-self: center;
		position: absolute;
		bottom: 23px;
		left: 50%;
		transform: translateX(-50%);
		width: 150px;
	}

	.com-header-title {
		width: 26.042vw;
		font-weight: 500;
		font-size: 2.083vw;
		margin-top: 10px;
	}

	.com-header-content {
		width: 26.042vw;
		font-weight: 400;
		font-size: .833vw;
		line-height: 2.083vw;
		margin-top: 1.563vw;
		margin-bottom: 1.563vw;
	}

	.box-card {
		width: 290px;
		height: 130px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		box-sizing: border-box;
		border-radius: 14px;
		border-top: 5px solid #0057de;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
	}

	.box-card img {
		width: 53px;
		padding: 2px;
	}

	.box-card span {
		display: block;
		align-items: center;
		text-align: center;
		vertical-align: top;
		text-wrap: nowrap;
		line-height: 32px;
		font-size: 18px;
		font-weight: bold;
		width: 230px;
		margin: auto;
	}


	.box-card:hover {
		border-top: 5px solid #ffe93e;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
		/* 设置上边框为加粗的黑色 */
	}

	.toolbox-card {
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		margin-left: 120px;
	}

	.toolbox-card .el-button {
		margin: 10px 40px;
	}

	.toolbox-card .span {
		display: inline-flex;
		align-items: center;
		vertical-align: top;
		text-wrap: nowrap;
		line-height: 32px;
	}

	.box-card-span {
		display: inline-flex;
		align-items: center;
		vertical-align: top;
		text-wrap: nowrap;
		line-height: 25px;
	}

	.com-content {
		display: flex;
		padding: 5px;
		justify-content: center;
		text-align: center;
		align-items: center;
	}

	.equal-height {
		display: flex;
		align-items: stretch;
		justify-content: center;
		box-sizing: border-box;
	}

	.row-header {
		transform: translateY(9%);
		width: 1500px;
		height: 160px;
		margin: auto;
		box-sizing: border-box;

	}
</style>
<style scoped>
	.com-header-row {

		height: 0;
		position: absolute;
		top: 0;
		left: 50%;
		transform: translate(-50%, 0);
		width: 80%;
		padding-top: 28%;
	}

	.com-header-avatar {
		display: flex;
		justify-content: space-between;
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		padding-top: 60px;
		box-sizing: border-box;
	}

	.com-header-col {
		display: flex;
		width: 17%;
		height: 100%;
		position: relative;
		align-items: stretch;
		justify-content: center;
		box-sizing: border-box;
	}

	.com-header-col img {
		height: 100%;
		top: 0;
		left: 0;
	}

	.com-header-col:hover {
		transform: scale(1.1);
	}
</style>